var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retrieve-pw-container-bg"},[_c('PassWordStep',{attrs:{"post":{ title: '找回密码' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }